module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.match_report) ? _c('div', [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-6 columns match-actions-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _c('tbody', {
    staticClass: "roster"
  }, _vm._l((_vm.match_report.home_report.player_report), function(action) {
    return (action.player) ? _c('tr', [_c('td', [_vm._v(_vm._s(action.player.num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_pass))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_ttm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_det))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_int))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_cas))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_td))]), _vm._v(" "), (action.mvp) ? _c('td', [_vm._v("Oui")]) : _c('td', [_vm._v("Non")]), _vm._v(" "), (action.nb_red_card) ? _c('td', [_vm._v("Oui")]) : _c('td', [_vm._v("Non")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_foul))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.bonus_xp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getWound(action.injury_type)))])]) : _vm._e()
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "large-6 columns match-actions-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', [_vm._m(1), _vm._v(" "), _c('tbody', {
    staticClass: "roster"
  }, _vm._l((_vm.match_report.visitor_report.player_report), function(action) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(action.player.num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_pass))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_ttm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_det))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_int))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_cas))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_td))]), _vm._v(" "), (action.mvp) ? _c('td', [_vm._v("Oui")]) : _c('td', [_vm._v("Non")]), _vm._v(" "), (action.nb_red_card) ? _c('td', [_vm._v("Oui")]) : _c('td', [_vm._v("Non")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.nb_foul))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.bonus_xp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getWound(action.injury_type)))])])
  }), 0)])])])])]) : _c('div', [_c('spinner')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "roster-head"
  }, [_c('tr', [_c('th', {
    attrs: {
      "width": "6%"
    }
  }, [_vm._v("N°")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Réu")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("TTM")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Det")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Int")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Sor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("TD")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "6%"
    }
  }, [_vm._v("JPV")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Expulsion")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Agro")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("XPB")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Blessure")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "roster-head"
  }, [_c('tr', [_c('th', {
    attrs: {
      "width": "6%"
    }
  }, [_vm._v("N°")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Réu")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("TTM")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Det")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Int")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Sor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("TD")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "6%"
    }
  }, [_vm._v("JPV")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Expulsion")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Agro")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("XPB")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Blessure")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d4bdb80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/match-reports/player-report-viewer.vue
// module id = 764
// module chunks = 0